export default {
    data() {
        return {
            list: [],//渲染的数据
            key: "",//关键字查询
            allList: [],//全部数据
            current: 1,//当前页
        }
    },
    computed: {//title由路由参数获得
        title() {
            return this.$route.query.title;
        }
    },
    watch: {
        title(val) { //每次更改关键字都要重新获取列表
            this.getBlogList();
            this.key = val;
        }
    },
    created() {
        this.key = this.$route.query.title;
        this.getBlogList();
    },
    methods: {
        //获取随笔列表
        async getBlogList() {
            const { API, $request, title } = this;
            if (!title) return alert("请先输入随笔标题!");
            const url = API.getBlogList;
            const { data: res } = await $request(url, "get", {
                title,
                status: "0",
            });
            const list = res.data || [];
            this.allList = list;
            this.list = list.slice(0, 10);
        },

        //确认查询
        sumbit() {
            if (this.key === this.title) return;
            this.$router.push({ path: '/search', query: { title: this.key } })
        },

        //加载更多
        loadmore() {
            if (this.list.length >= this.allList.length) return;
            this.current++;
            const start = (this.current - 1) * 10;
            const end = start + 10;

            const list = this.allList.slice(start, end);
            this.list = this.list.concat([...list]);
        }

    }
}